<template>
    <div class="d-flex h-screen">
        <img id="logo" src="../assets/ng-logo2.svg" alt="">
        <div id="form-div">
            <form @submit.prevent="loginHandler">
                <h1>Welcome!</h1>
                <input id="email" class="input-form" type="text" placeholder="Email" v-model="email"><br>
                <input id="password" class="input-form" type="password" placeholder="Password" v-model="password"><br>
                <div class="checkbox-container">
                    <label id="customControlInline">
                        <input type="checkbox" value="first_checkbox">Remember me
                    </label>
                </div>
                <button id="access-btn">Log in</button>
            </form>
        </div>
        <img id="login-img" src="../assets/log_in_foto.webp" />
        <div id="powered">
            <img id="powered-img" src="../assets/powered_nabla.png" alt="">
        </div>
    </div>
</template>

<script>
import api, { setAuthToken } from '@/api/api';
export default {
    name: 'LoginForm',
    data() {
        return {
            email: null,
            password: null,
            windfarms: []
        }
    },
    methods: {
    async loginHandler() {
      try {
        const username = this.email.toLowerCase();
        const response = await api.login(username, this.password);
        const token = response.data.access_token;
        const windfarms = response.data.windfarms;

        setAuthToken(token);
        this.$store.commit('login', { token, windfarms });
        this.$router.push('/dashboard');
      } catch (error) {
        console.error('Login error:', error);
        alert('Invalid email or password');
      }
    }
  }
}
</script>

<style scoped>
#form-div {
    width: 30%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

form {
    width: 50%;
    height: 50%;
}

label>input {
    margin-right: 10px;
}

label {
    padding-left: 2px;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #262840;
}

.input-form {
    border: none;
    border-bottom: 1px solid #262840;
    margin-bottom: 1rem;
    width: 100%;
    height: 15px;
    text-align: left !important;
}

form>h1 {
    font-style: normal;
    font-weight: 700;
    /*     font-size: 2.931rem;
    line-height: 4.375rem; */
    text-align: center;
    margin-bottom: 1.7rem;
    font-size: 32px;
    line-height: 70px;
    color: #262840;
}

h2 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    /*     font-size: 18.7143px; */
    font-size: 2vh;
    line-height: 30px;
    text-align: center;
}

.input-form:focus-visible {
    outline: none;
}

button {
    width: 100%;
    height: 30px;
    border: none;
    border-radius: 10px;
    background-color: #fba772;
    color: #ffffff;
    margin-top: 20px;
    margin-bottom: 20px;
    font-weight: 600;
    font-size: 16px;
}

button:hover {
    background: #FF8435;
}

#powered {
    position: absolute;
    bottom: 60px;
    right: 60px;
    size: 50%;
}

#logo {
    position: absolute;
    width: 130px;
    left: 35px;
    top: 35px;
}

#submit-forgot {
    text-align: left;
    font-size: 10px;
}

#customControlInline {
    font-size: 10px;
}

.checkbox-container {
    text-align: left !important;
}

#login-img {
    width: 70%;
}
</style>